import React, { useState, useEffect } from 'react';
import ResizeDetector from "react-resize-detector";
import { useDispatch, useSelector } from 'react-redux'
import 'react-phone-input-2/lib/style.css';
import { useNavigate } from 'react-router-dom';
import styles3 from '../../assets/css/newStyling.module.css'
import Swal from 'sweetalert'
import styles from '../../assets/css/rstyling.module.css'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { Input, Button } from 'reactstrap'
import { getSpecificOption } from '../../actions/settings_actions';
import moment from 'moment';
import SecureLS from 'secure-ls';
import { editUserDetails, newUserDetails, newUserDetailsTerms, newUserDetailsTest } from '../../actions/user_action';
import { cityOptions } from '../../actions/settings_actions';
import Loader from "react-loaders";
import LoadingOverlay from 'react-loading-overlay-ts';
import login_bg_new from "../../assets/images/login_bg2.png";
import PhoneInput from 'react-phone-input-2';


// currently used for signup questions for normal signup


const GuestProfile = () => {

    const dispatch = useDispatch()
    const history = useNavigate()
    const systemVariables = useSelector(state => state.SystemSettings.specificOptions)
    const [isLoading, setLoading] = useState(true)
    const ls = new SecureLS()
    const [cities, setCities] = useState([])
    const [incomes, setIncomes] = useState([])
    const [educations, setEducations] = useState([])

    const [userData, setUserData] = useState({
        userName: '',
        city: '',
        country: '',
        gender: '',
        education: '',
        occupation: '',
        income: '',
        phone:'',
        birthday: '',
        termsAccepted: false

    })


    const onSubmit = (values) => {
        let userAge = 0

        //console.log('onSubmit->', values)
        // calculating user age
        if (values.birthday !== "") {
            const today = new Date();
            const formattedBirthDate = new Date(values.birthday);
            let age = today.getFullYear() - formattedBirthDate.getFullYear();
            let m = today.getMonth() - formattedBirthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < formattedBirthDate.getDate())) {
                age--;
            }
            userAge = age
        }

        Swal({
            title: "Setting your profile",
            text: "Please wait",
            icon: 'info',
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
            onOpen: () => {
                Swal.showLoading();
            }
        });
      
        // ls.set('userType', 'guest')
        // const user = '64c0e8a349744823c3d82905'
        dispatch(newUserDetailsTest(ls.get('accessUser').user._id, values))
            .then(response => {
                // ls.set('accessUser', { user: response.payload.content })
                //console.log('user details in guest->', response.payload.content)
                // const UserId = response.payload.content._id
                // const ActivityId = '6400546130af823c80207cc0'
                Swal.stopLoading();
                Swal.close()
                
                
                
                history(`/signup-acknowleged`)
                //history('/respondent')


            })
            .catch((err) => {
                Swal({
                    title: err.response ? err.response.data.name : "Error",
                    text: err.content ? err.response.data.content : "Please try again!",
                    icon: 'error'
                })
            })
    }

    useEffect(() => {
        ls.get('userType') === 'guest' && history('/respondent/quick-survey')
        dispatch(getSpecificOption({ options: ["Education", "Income", "Countries", "Cities"] }))
            .then(response => {

            })
            .catch(err => {
               // console.log(err)
            })

        const loggedInUser = ls.get('accessUser').user
        if (loggedInUser.userName) {
            const birthDate = new Date(loggedInUser.birthday)

            setUserData({
                userName: loggedInUser.userName,
                city: loggedInUser.city,
                country: loggedInUser.country,
                gender: loggedInUser.gender,
                education: loggedInUser.education,
                occupation: loggedInUser.occupation,
                phone: loggedInUser.phone,
                income: loggedInUser.income,
                firstName: loggedInUser.firstName,
                lastName: loggedInUser.lastName,
                birthday: birthDate.getFullYear() + "-" + ("0" + (birthDate.getMonth() + 1)) + "-" + ("0" + (birthDate.getDate())).slice(-2),
                termsAccepted: loggedInUser.termsAccepted

            })
        }
        setLoading(false)
    }, [])

    const onSelectCountry = (value) => {



        dispatch(cityOptions(value))
            .then(response => {

                setCities(response.payload.content.cities)
                setIncomes(response.payload.content.incomes)
                setEducations(response.payload.content.educationData)
            })
            .catch(err => {
               // console.log(err)
            })
    }
    const waveKeyframes = `
    @keyframes wave-animation {
      0% { transform: rotate( 0.0deg) }
     10% { transform: rotate(14.0deg) }
     20% { transform: rotate(-8.0deg) }
     30% { transform: rotate(14.0deg) }
     40% { transform: rotate(-4.0deg) }
     50% { transform: rotate(10.0deg) }
     60% { transform: rotate( 0.0deg) }
    100% { transform: rotate( 0.0deg) }
  }`;

    const waveStyle = {
        display: 'inline-block',
        animation: 'wave-animation 0.8s infinite',
        transformOrigin: '70% 70%',
    };
    React.useEffect(() => {
        const styleTag = document.createElement('style');
        styleTag.type = 'text/css';
        styleTag.appendChild(document.createTextNode(waveKeyframes));
        document.head.appendChild(styleTag);
    }, []);

    return (
        <ResizeDetector
            handleWidth
            render={({ width, height }) => (
                <LoadingOverlay tag="div" active={isLoading}
                    styles={{
                        overlay: (base) => ({
                            ...base,
                            background: "#fff",
                            opacity: 0.5,
                            // position: 'fixed',
                            // top: '2%'
                        }),
                    }}
                    spinner={
                        <Loader color="#6c757d" active type="ball-pulse" />
                    }>


                    <div className="_signup_">

                        <div className="d-flex">
                            <div className="col-lg-8 col-12">

                                {/* Logo */}
                                <div className={height > 868 && width > 800 ? "container-fluid position-fixed m-3" : "container-fluid my-3 mr-3"}>
                                    <a href="/">
                                        <img src={require('../../assets/utils/images/logo.png')} alt="logo" width='135' />
                                    </a>
                                </div>

                                <div className="container">
                                    <div className={`row justify-content-center align-items-center ${height > 868 && width > 800 ? 'h-100' : 'mt-5'}`}>
                                        <div className="col-12">

                                            <h4 className="mb-5 ml-4">
                                                <h3 className="text-dark mb-2" style={{ fontWeight: '500' }}>Hello <span style={waveStyle}>👋</span> </h3>
                                                <p style={{ fontSize: '1rem' }}>It takes only seconds to fill up the basic details.</p>
                                            </h4>

                                            {/* <div className="row"> */}

                                            <Formik
                                                initialValues={userData}
                                                enableReinitialize={true}
                                                onSubmit={(values, { setSubmitting }) => {
                                                    setSubmitting(true)
                                                    onSubmit(values)

                                                }}


                                                const validationSchema={Yup.object().shape({
                                                    userName: Yup.string().required("Username is required"),
                                                    city: Yup.string().required("City is required"),
                                                    country: Yup.string().required("Country is required"),
                                                    gender: Yup.string().required("Gender is required"),
                                                    education: Yup.string().required("Education is required"),
                                                    occupation: Yup.string().required("Occupation is required"),
                                                    income: Yup.string().required("Monthly Income is required"),
                                                    phone: Yup.string().required("Phone number is required"),
                                                    termsAccepted: Yup.boolean().oneOf([true], 'You must accept the terms and conditions.'),
                                                    birthday: Yup.date().required("Birth Date is required")
                                                        .test("DOB", "Min age should be 13", (value) => {
                                                            return moment().diff(moment(value), "years") > 13;
                                                        }),
                                                })}


                                            >
                                                {props => {
                                                    const {
                                                        values,
                                                        touched,
                                                        errors,

                                                        handleChange,
                                                        handleBlur,
                                                        handleSubmit,
                                                        setFieldValue,

                                                    } = props;

                                                    const onAcceptTerms = (event) => {
                                                        const { name, checked } = event.target;
                                                       

                                                        handleChange(event); // Use handleChange to update the form field value
                                                    };

                                                    return (
                                                        <form autoComplete="off" onSubmit={handleSubmit}>

                                                            {/* Start of form */}
                                                            <div className='row mx-2'>
                                                                <div className="col-md-6 col-12 mb-3">
                                                                    <div className="form-group">
                                                                        <label style={{ fontSize: '1rem', fontWeight: '600', color: '#666' }}>User Name</label>
                                                                        <Input type="text"
                                                                            className={errors.userName && touched.userName ? styles.is_invalid : 'valid'}
                                                                            name="userName"
                                                                            placeholder="Username"
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            value={values.userName}
                                                                        />

                                                                        {errors.userName && touched.userName && (
                                                                            <small className='text-danger'>
                                                                                {errors.userName}
                                                                            </small>
                                                                        )}

                                                                    </div>
                                                                </div>

                                                                <div className="col-md-6 col-12 mb-3">
                                                                    <div className="form-group">
                                                                        <label style={{ fontSize: '1rem', fontWeight: '600', color: '#666' }}>Phone Number</label>
                                                                        <PhoneInput
                                                                            inputStyle={{ width: '100%', height: '38px', borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                                                                            country={'pk'}
                                                                            name='phone'
                                                                            type='text'
                                                                            value={values.phone}
                                                                            onChange={(phone) => {
                                                                                //setPhoneAndNetwork(phone, country.name);
                                                                                setFieldValue('phone', phone)
                                                                            }}

                                                                            enableSearch={true}

                                                                        />
                                                                        {errors.phone && touched.phone && (
                                                                            <small className='text-danger'>
                                                                                {errors.phone}
                                                                            </small>
                                                                        )}
                                                                    </div>
                                                                </div>


                                                                <div className="col-md-6 col-12 mb-3">
                                                                    <div className="form-group">
                                                                        <label style={{ fontSize: '1rem', fontWeight: '600', color: '#666' }}>Gender</label>
                                                                        <Input type="select" name="gender"

                                                                            // className={errors.gender && touched.gender ? styles.is_invalid : 'form-control valid'}
                                                                            className={'form-control valid'}
                                                                            placeholder="Gender"
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            value={values.gender}
                                                                        >
                                                                            <option value="">Select</option>
                                                                            <option value="Male">Male</option>
                                                                            <option value="Female">Female</option>
                                                                        </Input>

                                                                        {errors.gender && touched.gender && (
                                                                            <small className='text-danger'>
                                                                                {errors.gender}
                                                                            </small>
                                                                        )}
                                                                    </div>
                                                                </div>


                                                                <div className="col-md-6 col-12 mb-3">
                                                                    <div className="form-group">
                                                                        <label style={{ fontSize: '1rem', fontWeight: '600', color: '#666' }}>Country</label>
                                                                        <Input type="select" name="country"
                                                                            className={'form-control valid'}
                                                                            placeholder="Country"
                                                                            onChange={handleChange}
                                                                            onInput={(e) => onSelectCountry(e.target.value)}
                                                                            onBlur={handleBlur}
                                                                            value={values.country}
                                                                        >
                                                                            <option value="">Select</option>
                                                                            {
                                                                                systemVariables.countries && systemVariables.countries.map(country => {
                                                                                    return <option value={country.name}>{country.name}</option>
                                                                                })
                                                                            }
                                                                        </Input>

                                                                        {errors.country && touched.country && (
                                                                            <small className='text-danger'>
                                                                                {errors.country}
                                                                            </small>
                                                                        )}
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-6 col-12 mb-3">
                                                                    <div className="form-group">
                                                                        <label style={{ fontSize: '1rem', fontWeight: '600', color: '#666' }}>City</label>
                                                                        <Input type="select" name="city"
                                                                            className={'form-control valid'}
                                                                            placeholder="City"
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            value={values.city}
                                                                        >
                                                                            <option value="">Select</option>
                                                                            {
                                                                                // systemVariables.cities && systemVariables.cities.map(city => {
                                                                                //     return <option value={city.name}>{city.name}</option>
                                                                                // })
                                                                                cities && cities.map(city => {
                                                                                    return <option value={city.name}>{city.name}</option>
                                                                                })
                                                                            }
                                                                        </Input>

                                                                        {errors.city && touched.city && (
                                                                            <small className='text-danger'>
                                                                                {errors.city}
                                                                            </small>
                                                                        )}
                                                                    </div>
                                                                </div>





                                                                <div className="col-md-6 col-12 mb-3">

                                                                    <div className="form-group">
                                                                        <label style={{ fontSize: '1rem', fontWeight: '600', color: '#666' }}>Date of Birth</label>

                                                                        <Input
                                                                            type="date"
                                                                            className={errors.birthday && touched.birthday ? styles.is_invalid : 'valid'}
                                                                            max={moment().format("YYYY-MM-DD")}
                                                                            name="birthday"
                                                                            placeholder="birthDay"
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            value={values.birthday}
                                                                        >
                                                                        </Input>
                                                                        {errors.birthday && touched.birthday && (
                                                                            <small className='text-danger'>
                                                                                {errors.birthday}
                                                                            </small>
                                                                        )}
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-6 col-12 mb-3">
                                                                    <div className="form-group">
                                                                        <label style={{ fontSize: '1rem', fontWeight: '600', color: '#666' }}>Monthly House Income</label>
                                                                        <Input type="select"
                                                                            className={'form-control valid'}
                                                                            name="income"
                                                                            placeholder="income"
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            value={values.income}
                                                                        >
                                                                            <option value="">Select</option>
                                                                            {
                                                                                // systemVariables.incomeRange && systemVariables.incomeRange.map(income => {
                                                                                //     return <option value={income.name}>{income.name}</option>
                                                                                // })
                                                                                incomes && incomes.map(income => {
                                                                                    return <option value={income.name}>{income.name}</option>
                                                                                })
                                                                            }
                                                                        </Input>

                                                                        {errors.income && touched.income && (
                                                                            <small className='text-danger'>
                                                                                {errors.income}
                                                                            </small>
                                                                        )}
                                                                    </div>
                                                                </div>


                                                                <div className="col-md-6 col-12 mb-3">
                                                                    <div className="form-group">
                                                                        <label style={{ fontSize: '1rem', fontWeight: '600', color: '#666' }}>Education</label>
                                                                        <Input type="select" name="education"
                                                                            className={'form-control valid'} placeholder="education"
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            value={values.education}
                                                                        >
                                                                            <option value="">Select</option>
                                                                            {
                                                                                // systemVariables.educationLevel && systemVariables.educationLevel.map(education => {
                                                                                //     return <option value={education.name}>{education.name}</option>
                                                                                // })
                                                                                educations && educations.map(city => {
                                                                                    return <option value={city.name}>{city.name}</option>
                                                                                })
                                                                            }
                                                                        </Input>

                                                                        {errors.education && touched.education && (
                                                                            <small className='text-danger'>
                                                                                {errors.education}
                                                                            </small>
                                                                        )}
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-6 col-12 mb-3">
                                                                    <div className="form-group">
                                                                        <label style={{ fontSize: '1rem', fontWeight: '600', color: '#666' }}>Occupation</label>
                                                                        <Input type="text"
                                                                            className={errors.occupation && touched.occupation ? styles.is_invalid : 'valid'}
                                                                            name="occupation"
                                                                            placeholder="Occupation"
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            value={values.occupation}
                                                                        />

                                                                        {errors.occupation && touched.occupation && (
                                                                            <small className='text-danger'>
                                                                                {errors.occupation}
                                                                            </small>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6 col-12 mb-3">
                                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                        <Input
                                                                            type="checkbox"
                                                                            name="termsAccepted"
                                                                            checked={values.termsAccepted}
                                                                            // value={values.terms ? false: true}
                                                                            onChange={onAcceptTerms}
                                                                            // onInput={values.terms == true}
                                                                            unChecked={values.termsAccepted}

                                                                        />
                                                                        <span style={{ marginLeft: '8px' }}>
                                                                            I have read and I accept the <a href='https://consumerconnect.net/terms-of-use/'> terms and conditions</a>
                                                                        </span>
                                                                    </div>
                                                                    {touched.termsAccepted && errors.termsAccepted && (
                                                                        <small className='text-danger'>
                                                                            {errors.termsAccepted}
                                                                        </small>
                                                                    )}

                                                                </div>

                                                                {/* </div> */}
                                                                <div className="col-md-6 col-sm-12 text-right">
                                                                    <Button className={`${styles.bg_blue} btn-hover-shine text-light w-100 mb-2`} type="submit">Continue</Button>
                                                                </div>

                                                            </div>
                                                        </form>
                                                    )
                                                }}

                                            </Formik>

                                            {/* </div> */}



                                        </div>
                                    </div>
                                </div>


                            </div>
                            <div className="col-lg-4 d-lg-block d-none px-0" style={{position:'fixed', top:'0px', right:'0px'}}>
                                {/* Gradient Overlay */}
                                {/* <div className="grad_overlay"></div>

                                <div className="text-center px-3">
                                    <div className="d-flex justify-content-center align-items-center h-100">
                                        <div className="col-12">
                                           
                                            <h4 style={{ color: "#eee", fontWeight: '500', lineHeight: '2.65rem', letterSpacing: '2px' }}>
                                                Genuinely Connecting Consumers to Brands.
                                                Influence change in the world with your Voice!
                                            </h4>
                                        </div>
                                    </div>
                                </div> */}
                                 <div className="">
                                    <div className="d-flex align-items-center h-100" style={{position:'sticky', top:'0px'}}>
                                        <div className="col-12">
                                            {/* <h3 className="mb-4" style={{ color: "#eee", fontWeight: '700', lineHeight: '2.65rem', letterSpacing: '2px' }}>Signup now</h3> */}
                                            {/* <h4 style={{ color: "#eee", fontWeight: '500', lineHeight: '2.65rem', letterSpacing: '2px' }}>
                                                Genuinely Connecting Consumers to Brands.
                                                Influence change in the world with your Voice!
                                            </h4> */}
                                            

                                                <div className={`${styles3.login_img_signup}`}
                                                    style={{
                                                        backgroundImage: "url(" + login_bg_new + ")",
                                                    }} />


                                           
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div >

                    </div >

                </LoadingOverlay>



            )
            }
        />

    )

}

export default GuestProfile;